export const SET_TECHNICIAN_DATA = 'SET_TECHNICIAN_DATA';